import Select from 'components/Forms/Select/Select';
import { StoreTerritorialUnitType } from 'connectors/stores/StoreLocator';
import useTranslation from 'next-translate/useTranslation';
import { SelectOptionType } from 'types/selectOptions';

type StoreTerritorialFiltersProps = {
    areTerritorialUnitsLoading: boolean;
    selectedDistrict: string;
    selectedRegion: string;
    territorialUnits: StoreTerritorialUnitType[];
    onDistrictChange: (value: string) => void;
    onRegionChange: (value: string) => void;
    onTerritorialSelectorFocus: () => void;
};

export const StoreTerritorialFilters: FC<StoreTerritorialFiltersProps> = ({
    areTerritorialUnitsLoading,
    selectedDistrict,
    selectedRegion,
    territorialUnits,
    onDistrictChange,
    onRegionChange,
    onTerritorialSelectorFocus,
}) => {
    const { t } = useTranslation();
    const regionOptions: SelectOptionType[] = [
        { value: '', label: t('All regions') },
        ...Array.from(new Set(territorialUnits.map(({ region }) => region))).map((region) => ({
            value: region,
            label: region,
        })),
    ];
    const districtOptions: SelectOptionType[] = [
        { value: '', label: t('All districts') },
        ...Array.from(
            new Set(
                territorialUnits
                    .filter(({ region }) => selectedRegion === '' || region === selectedRegion)
                    .map(({ district }) => district),
            ),
        )
            .filter((district): district is string => district !== null && district !== '')
            .map((district) => ({ value: district, label: district })),
    ];

    return (
        <>
            <Select
                hasError={false}
                id="store-region-select"
                isLoading={areTerritorialUnitsLoading}
                label={t('Region')}
                options={regionOptions}
                value={regionOptions.find(({ value }) => value === selectedRegion) ?? null}
                onChange={(option) => onRegionChange((option as SelectOptionType | null)?.value ?? '')}
                onFocus={onTerritorialSelectorFocus}
            />
            <Select
                hasError={false}
                id="store-district-select"
                isLoading={areTerritorialUnitsLoading}
                label={t('District')}
                options={districtOptions}
                value={districtOptions.find(({ value }) => value === selectedDistrict) ?? null}
                onChange={(option) => onDistrictChange((option as SelectOptionType | null)?.value ?? '')}
                onFocus={onTerritorialSelectorFocus}
            />
        </>
    );
};
